<template>
    <div>
        <b-breadcrumb :items="breadcrumbItems"></b-breadcrumb>
        <b-row v-if="! loading" class="mb-2">
            <b-col class="col-12">
                <b-card class="mb-0">
                    <b-card-title title-tag="h5" title="Teams"></b-card-title>
                    <b-card-body class="px-0">
                        <b-form @submit.prevent="createTeam">
                            <b-form-group label="Name" label-for="name" :state="errors.name ? false : null">
                                <b-form-input id="name" v-model="team.name" :state="errors.name ? false : null"></b-form-input>
                                <b-form-invalid-feedback id="name_feedback">{{ errors.name ? errors.name[0] : '' }}</b-form-invalid-feedback>
                            </b-form-group>
                            <color-picker v-model="team.color" label-name="Color" :state="errors.color ? false : null"></color-picker>
                            <color-picker v-model="team.text_color" label-name="Text Color" :state="errors.text_color ? false : null" class="mb-2"></color-picker>
                            <b-button type="submit" variant="primary">Save</b-button>
                        </b-form>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    props: {
        teamRaw: {
            default: false,
        }
    },
    data() {
        return {
            team: {
                name: '',
                color: '#000000',
                text_color: '#ffffff',
            },
            errors: [],
            loading: false,
            breadcrumbItems: [
                {text: 'Home', to: {name: 'home'}},
                {text: 'Teams', to: {name: 'team.index'}},
                {text: 'Create Team', active: true},
            ]
        }
    },
    methods: {
        createTeam() {
            if (this.teamRaw) {
                axios.put(this.$routes.route('team.update', {team: this.team.id}), this.team)
                    .then(response => {
                        window.location.href = this.$routes.route('team.index');
                    })
                    .catch(error => {
                        this.errors = error.response.data.errors;
                    });
            } else {
                axios.post(this.$routes.route('team.store'), this.team)
                    .then(response => {
                        window.location.href = this.$routes.route('team.index');
                    })
                    .catch(error => {
                        this.errors = error.response.data.errors;
                    });
            }
        },
        init() {
            this.breadcrumbItems = [
                {
                    text: "Teams",
                    href: this.$routes.route('team.index'),
                },
            ];
            if (this.teamRaw) {
                this.team = this.teamRaw;
                this.breadcrumbItems.push({
                    text: `Edit ${this.team.name}`,
                    active: true,
                });
            } else {
                this.breadcrumbItems.push({
                    text: 'Create Team',
                    active: true,
                });
            }

            this.loading = false;
        },
    },
    mounted() {
        this.loading = true;
        this.init();
    }
}
</script>